export const SUBSCRIPTIONS_PATH = '/api/internal/realtime/subscriptions';

export const RealtimeConfig = Object.freeze({
  /** Only path hardcoded here: the stream URL comes back with the subscription. */
  SUBSCRIPTIONS_PATH,
  SUBSCRIPTION_QUERY_PARAM: 'subscription',

  INITIAL_RETRY_DELAY_MS: 1000,
  MAX_RETRY_DELAY_MS: 60000,
  /** Debounce so several components subscribing in one render open one stream. */
  RECONNECT_DEBOUNCE_MS: 250,
  /**
   * A backgrounded tab must not hold a Cloud Run concurrency slot for hours.
   * Coming back reopens the stream, which refetches (see `client.js`).
   */
  HIDDEN_TAB_CLOSE_DELAY_MS: 5 * 60 * 1000,
});
